import {IEditCycle} from '@core/api/data-access';

import {ValidatorResults, ValidatorTestResult} from './entity-validator.types';
import {CycleTriggerValidator, FieldValidator, StationValidator} from './subs';

export namespace CycleValidator {
	import validateStations = StationValidator.validateStations;
	import validateFields = FieldValidator.validateFields;
	import validateTriggers = CycleTriggerValidator.validateTriggers;
	export type CycleValidatorType = 'name' | 'stations' | 'fields' | 'triggers';
	export type CycleValidatorResult = ValidatorResults<CycleValidatorType>;

	export function validateFullEditCycle(cycle: IEditCycle, tests: Partial<Record<CycleValidatorType, boolean>>): CycleValidatorResult {
		const result: CycleValidatorResult = {
			allValid: true,
			fields: {valid: true, errors: []},
			name: {valid: true, errors: []},
			stations: {valid: true, errors: []},
			triggers: {valid: true, errors: []},
		};

		if (tests.name) {
			result.name = validateCycleName(cycle);
		}

		if (tests.stations) {
			result.stations = validateStations(cycle.stations);
		}

		if (tests.fields) {
			result.fields = validateFields(cycle.fields);
		}

		if (tests.triggers) {
			result.triggers = validateTriggers(cycle.triggers);
		}

		result.allValid = Object.keys(result).every(key => result[key].valid);

		return result;
	}

	export function validateCycleName(cycle: IEditCycle): ValidatorTestResult {
		const name = cycle.name;
		if (!name) return {valid: false, errors: ['Cycle name is required']};
		return {valid: true};
	}
}
